import { addContextUpdateListener, getContext } from '@dvag/dfs-orchestrator-client';
import { FeatureDefinition, GrowthBook } from '@growthbook/growthbook-react';

type FeatureFlag = {
  gb: GrowthBook<Record<string, unknown>>;
  init: () => void;
};

export const getHouseholdIdFromPathname = (pathname: string) => {
  const pathParts = pathname.split('/').filter(Boolean);
  const householdSegmentIndex = pathParts.indexOf('haushalt');

  if (householdSegmentIndex >= 0) {
    return pathParts[householdSegmentIndex + 1];
  }

  return pathParts[1];
};

const featureFlag: FeatureFlag = {
  gb: new GrowthBook(),
  init: () => {
    const initFeatures = getContext().featureFlags as unknown as Record<
      string,
      FeatureDefinition<unknown>
    >;
    const householdId = getHouseholdIdFromPathname(window.location.pathname);
    const payload = {
      features: initFeatures,
      attributes: {
        advisorId: getContext().user.advisor.id,
        householdId,
      },
    };
    featureFlag.gb = new GrowthBook(payload);

    featureFlag.gb.initSync({
      payload,
    });
    addContextUpdateListener(({ featureFlags }) => {
      const updatedFeatures = featureFlags as unknown as Record<string, FeatureDefinition<unknown>>;
      featureFlag.gb.setPayload({
        ...payload,
        features: updatedFeatures,
      });
    });
  },
};

export default featureFlag;
